import React from 'react';
import { Flex, Loader as CbLoader } from '@grubhubprod/gh-cookbook-react/dist';

export default function Loader(): JSX.Element {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      position="absolute"
      width="100%"
      height="100%"
      zIndex={10}
      data-testid="Loader"
    >
      <CbLoader size="md" />
    </Flex>
  );
}
